const runtime = window.__APP_CONFIG__ || {};

export default {
    baseUrl: runtime.baseUrl || '',
    apiUrl: runtime.apiUrl || '',
    authUrl: runtime.authUrl || runtime.apiUrl || '',
    clientId: runtime.clientId || '',
    scope: runtime.scope || 'sms',
    panelApiPrefix: runtime.panelApiPrefix || 'api/panel/v2',
};
